import React from 'react';
import { SkeletonLine, SkeletonStatus } from '../Components/skeleton/SkeletonPieces';

/**
 * The supporters list's loading placeholder, shaped like the list it stands in
 * for: the same full-width card (1px edge, card radius, card shadow, 20 inset,
 * 8 top and bottom), and per row a name line on the 22 line and a
 * time-and-place line on the 18 line, 12 above and below, with the list's
 * subtle rule between rows (G3H-0).
 *
 * It is the ONE placeholder for all three moments a donor can be waiting on
 * this list, and they must stay the same frame:
 *   - the element's Suspense fallback while the chunk loads
 *     (`NonFormSkeleton` with the donor-list type, from `App.jsx`),
 *   - `SupportersList`'s own `loading` branch while `/elements-config` fetches,
 *   - the hosted page's Suspense fallback (`SupportersListBooting`).
 */
const ROW_COUNT = 4;
const NAME_WIDTHS = ['w-[70%]', 'w-3/5', 'w-2/3', 'w-1/2'];
const META_WIDTHS = ['w-[45%]', 'w-2/5', 'w-1/3', 'w-2/5'];

export function SupportersListSkeleton() {
  return (
    <SkeletonStatus
      label="Loading supporters list"
      className="flex w-full flex-col rounded-[var(--cs-card-radius)] border border-[color:var(--cs-border-control)] bg-[color:var(--cs-surface-0)] px-[var(--cs-space-5)] py-[var(--cs-space-2)] shadow-[var(--cs-card-shadow)]"
    >
      {Array.from({ length: ROW_COUNT }, (_, index) => (
        <div
          key={index}
          aria-hidden="true"
          className={`flex w-full flex-col py-[var(--cs-space-3)]${
            index === ROW_COUNT - 1 ? '' : ' border-b border-[color:var(--cs-border-control-subtle)]'
          }`}
        >
          <div className="flex h-[var(--cs-leading-22)] items-center">
            <SkeletonLine leading="var(--cs-leading-16)" className={NAME_WIDTHS[index]} />
          </div>
          <div className="flex h-[var(--cs-leading-18)] items-center">
            <SkeletonLine leading="var(--cs-leading-14)" className={META_WIDTHS[index]} />
          </div>
        </div>
      ))}
    </SkeletonStatus>
  );
}

export default SupportersListSkeleton;
